import React from 'react'
import {
  Sidebar,
  List,
  ListNav,
  Featured
} from './index'
import {
  Pagination,
  ListFilter
} from '../../../components'
import { Statistics } from '../../program-statistic/components'
import programs from '../../../database/initiatives.json'

const ListView = ({filtered, setFiltered, uniform, embed, data}) => {
  return (
    <div>
      {
        (!filtered && !embed) &&
        <Featured embed={embed}/>
      }
      <ListFilter filtered={filtered} setFiltered={setFiltered}/>
      <List data={data} uniform={uniform} />
    </div>
  )
}

const StatisticView = ({filtered}) => {
  return (
    <div>
      <h2 className="text-2xl text-center lg:text-left lg:text-4xl font-accent font-bold uppercase mb-5 lg:mb-10">Program Statistic</h2>
      <Statistics filtered={filtered} withoutOrganization/>
    </div>
  )
}

const MainContent = ({fromOrganization, uniform, embed, byId, programIds}) => {
  const [filtered, setFiltered] = React.useState(false)
  const [activeTab, setActiveTab] = React.useState('List View')
  const [data, setData] = React.useState(programs)

  React.useEffect(() => {
    if(filtered){
      setData(programs.slice(0, 3))
    }else{
      setData(programs)
    }
  }, [filtered])

  React.useEffect(() => {
    if(byId && programIds){
      const result = programs.filter(d => programIds.includes(d.id))
      setData(result)
    }
  }, [byId, programIds])

  // React.useEffect(() => {
  //   if (
  //     defaultTab
  //     && defaultTab.length > 0
  //     && defaultTab !== false
  //   ) {
  //     setActiveTab(defaultTab)
  //   }
  // }, [defaultTab])

  return (
    <section className="container mx-auto hidden lg:block">
      <div className={`flex flex-wrap -mx-4 ${embed ? 'pb-16' : 'py-16'}`}>
        {
          !embed &&
          <aside className="w-3/12 px-4">
            <Sidebar filtered={filtered} setFiltered={setFiltered}/>
          </aside>
        }
        <main className={`${embed ? 'w-full' : 'w-9/12'} px-4`}>
          {
            !embed &&
            <ListNav
              fromOrganization={fromOrganization}
              onChange={setActiveTab}
              activeTab={activeTab}
            />
          }
          {
            activeTab === 'List View' &&
            <ListView
              filtered={filtered}
              setFiltered={setFiltered}
              embed={embed}
              uniform={uniform}
              data={data}
            />
          }
          {
            activeTab === 'Statistic View' &&
            <StatisticView filtered={filtered}/>
          }
          {
            !embed &&
            <Pagination />
          }
        </main>
      </div>
    </section>
  )
}

export { MainContent }
